import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseSiteService } from '@spartacus/core';
import { StartOrderService } from '../start-order.service';

@Component({
  selector: 'app-quantitypopup',
  standalone: false,
  templateUrl: './quantitypopup.component.html',
  styleUrls: ['./quantitypopup.component.scss']
})
export class QuantitypopupComponent {
  productdata:any=[];
  prebookproductlist:any=[];
  originaldata:any=[];
  shipping:any=[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,private startOrderService: StartOrderService,private cd:ChangeDetectorRef,public dialogRef: MatDialogRef<QuantitypopupComponent>
  ) {
    this.productdata=data[0];
    this.prebookproductlist=data[1];
    this.shipping=data[2]
 /*  this.shipping.forEach((element:any) => {
    this.productdata.forEach((prod:any)=>{
      element['productCode']=prod.productCode
      prod.shipLocationQty.forEach((each:any)=>{
        if(element.locID==each.locID){
          element['productCode']=prod.productCode;
          element['locqty']=prod.locQty;
          element['increaseaty']=prod.increaseqty
        }

      })
     
    });
    
  }); */
    console.log(this.productdata,this.shipping);
  }

  close(res:boolean){
    this.dialogRef.close();
    this.startOrderService.setquantityData(res)

  }
}
